import { useTranslation } from 'react-i18next';
import {
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from '@monorepo/nova-ui';

export const BalanceSwitchOption = {
  transactions: 'transactions',
  availableCredit: 'availableCredit',
} as const;

export type BalanceSwitchOption =
  (typeof BalanceSwitchOption)[keyof typeof BalanceSwitchOption];

interface BalanceSwitchButtonProps {
  selectedOption?: BalanceSwitchOption;
  onOptionChange?: (option: BalanceSwitchOption) => void;
}

const BalanceSwitchButton = ({
  selectedOption = BalanceSwitchOption.transactions,
  onOptionChange,
}: BalanceSwitchButtonProps) => {
  const { palette } = useTheme();

  const handleOptionClick = (
    _event: React.MouseEvent<HTMLElement>,
    option: BalanceSwitchOption,
  ) => {
    onOptionChange?.(option);
  };
  const theme = useTheme();
  const { t } = useTranslation('hubCommon');

  const balanceSwitchOptions = Object.values(BalanceSwitchOption);

  return (
    <Stack direction="row" sx={{ marginBottom: theme.typography.pxToRem(12) }}>
      <ToggleButtonGroup
        value={selectedOption}
        exclusive
        onChange={handleOptionClick}
        sx={{
          maxHeight: theme.typography.pxToRem(32),
          display: { xs: 'none', sm: 'flex' },
          transformOrigin: 'left center',
        }}
      >
        {balanceSwitchOptions.map((option, index) => (
          <ToggleButton key={index} value={option}>
            <Typography
              variant="body1"
              sx={{ color: palette.text.second, whiteSpace: 'nowrap' }}
            >
              {t(option)}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default BalanceSwitchButton;
